/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .editable-schema-field-template {
    position: relative;
    margin-top: auto;
    border: 1px solid transparent;
    border-radius: 15px;
    transition: transform 250ms ease-in-out;

    & fieldset,
    & .prop-fields {
      padding: 8px;
    }

    &.is-hidden {
      opacity: 0.7;
    }

    .editable-schema-field-template-toolbar {
      position: absolute;
      visibility: hidden;
      top: 0;
      right: 6px;
      display: flex;
      gap: 4px;

      &.editable-schema-field-template-toolbar-root {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .editable-schema-field-template-toolbar-btn {
        padding: 0;
        position: relative;
        border: none;
        background: transparent;
        font-size: 12px;
        z-index: 10;
        transition: transform 100ms ease-in-out;

        &:hover {
          transform: scale(1.15);
        }
      }
    }

    &.form-group {
      padding: 8px !important;
    }

    .form-group.field-object {
      border-radius: 15px;
    }

    legend.type-section {
      width: auto !important;
      pointer-events: none;
      background-color: inherit !important;
    }

    &.is-selected {
      border: 1px solid ${$.infoMain};
      background-color: #fafafa;
    }

    &.is-hovered,
    &.is-selected {
      > .editable-schema-field-template-toolbar {
        visibility: visible;
      }
    }

    &.is-hovered:not(:has(.is-hovered)):not(.is-selected) {
      border: 1px dashed #dedede;
      background-color: #fafafa;
    }

    &.is-hovered:not(:has(.editable-schema-field-template)),
    &.is-selected:not(:has(.editable-schema-field-template)) {
      transform: scale(1.03);
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }
  }
`;
